import type RouterService from "@ember/routing/router-service";
import Service, { service } from "@ember/service";
import type SemeiaSessionService from "parog-web/services/session";

export default class AnalyticsService extends Service {
  @service declare router: RouterService;
  @service declare session: SemeiaSessionService;

  // This will configure Matomo analytics integration and start
  // the automatic route tracking. Every time the Ember router enters
  // a new route, an event is sent to Matomo.
  // The Matomo User ID is built as Medic_XXX or Patient_YYY.
  startRouterTracking() {
    const router = this.router;
    router.on("routeDidChange", () => {
      const page = router.currentURL;
      const title = router.currentRouteName || "unknown";
      const _paq = window._paq || [];
      _paq.push(["setCustomUrl", "/" + page]);
      _paq.push(["setDocumentTitle", title]);

      if (this.session.medic) {
        _paq.push(["setUserId", "Medic_" + this.session.medic.id]);
      } else if (this.session.patient) {
        _paq.push(["setUserId", "Patient_" + this.session.patient.id]);
      }
      _paq.push(["trackPageView"]);
    });
  }

  trackEvent(category: string, action: string, name: string, value?: string) {
    const _paq = window._paq || [];
    _paq.push(["trackEvent", category, action, name, value]);
  }

  // When a Journal Event is created by the app, an event should be sent
  // to Matomo using this function. This is used mostly in forms' blockSave().
  trackJeCreation(je) {
    this.trackEvent("JournalEvent", "creation", je.constructor.type);
  }
}
